var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-FAQ" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "faq-list" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-6" },
            _vm._l(_vm.getHalfFaq(1), function(item, index) {
              return _c(
                "div",
                {
                  staticClass: "faq__item",
                  class: { open: index === _vm.current_index }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-10",
                        on: {
                          click: function($event) {
                            return _vm.openFaq(index)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "titles" }, [
                          _c(
                            "p",
                            { staticClass: "min-med p-dgrey  mb-0 p-bold" },
                            [_vm._v(_vm._s(index) + _vm._s(item.title))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          index === _vm.current_index
                            ? _c("div", { staticClass: "content" }, [
                                _c(
                                  "p",
                                  { staticClass: "min-min p-dgrey mb-0" },
                                  [_vm._v(_vm._s(item.content))]
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-2" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon",
                          on: {
                            click: function($event) {
                              return _vm.openFaq(index)
                            }
                          }
                        },
                        [_c("span"), _vm._v(" "), _c("span")]
                      )
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-lg-6 second__section" },
            _vm._l(_vm.getHalfFaq(), function(item, index) {
              return _c(
                "div",
                {
                  staticClass: "faq__item",
                  class: { open: index === _vm.current_index }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-10",
                        on: {
                          click: function($event) {
                            return _vm.openFaq(item.id)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "titles" }, [
                          _c(
                            "p",
                            { staticClass: "min-med p-dgrey  mb-0 p-bold" },
                            [_vm._v(_vm._s(item.id) + _vm._s(item.title))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          item.id === _vm.current_index
                            ? _c("div", { staticClass: "content" }, [
                                _c(
                                  "p",
                                  { staticClass: "min-min p-dgrey mb-0" },
                                  [_vm._v(_vm._s(item.content))]
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-2" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon",
                          on: {
                            click: function($event) {
                              return _vm.openFaq(index)
                            }
                          }
                        },
                        [_c("span"), _vm._v(" "), _c("span")]
                      )
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "title" }, [
        _c(
          "h3",
          { staticClass: "h1 p-title p-black p-center mb-0 relawayBold" },
          [_vm._v("FAQ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }